import React, { PropsWithChildren } from 'react';

export function ContentCardName({ children }: PropsWithChildren) {
  return <p className="font-bold-14-20">{children}</p>;
}
